import axios from 'axios';
import toastr from 'toastr';
import axiosRetry from 'axios-retry';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';
import GestorDocumentalServices from '../gestorDocumental/gestorDocumental.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getVaccinesEmp = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_VACCINES_EMP,
      payload: true
    });
    //  
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(data.itype === 1 ? `/api/app/Formal_Empleado_Vacuna/` : `/api/app/Funcional_Empleado_Vacuna/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_VACCINES_EMP,
      payload: {
        vacsEmp: resp.data.data,
        vacsEmpLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_VACCINES_EMP,
      payload: false
    });
  }
}

export const saveVaccinesEmp = (data, itype, rqGD) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_VACCINES_EMP,
      payload: true
    });
     debugger;
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(itype === 1 ? `/api/app/Formal_Empleado_Vacuna/` : `/api/app/Funcional_Empleado_Vacuna/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    
    rqGD.id_registro = resp.data.id;
    const respGD = await GestorDocumentalServices.saveDocument(rqGD);
    const respPUTVac = await client.put(itype === 1 ? `/api/app/Formal_Empleado_Vacuna/${resp.data.id}/` : `/api/app/Funcional_Empleado_Vacuna/${resp.data.id}/`, {
      ...data,
      archivos_gestor: respGD.data.resultado.id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { vacsEmp, vacsEmpLength } = getState().vaccinesEmp;
    //vacsEmp.archivos_gestor = respGD.data.resultado;
    const aVacsEmp = [...vacsEmp, respPUTVac.data];
    
    dispatch({
      type: actions.GET_VACCINES_EMP,
      payload: {
        vacsEmp: aVacsEmp,
        vacsEmpLength: vacsEmpLength + 1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_VACCINES_EMP,
      payload: false
    });
  }
}

export const editVaccinesEmp = (data, id, index, itype, rqGD, arGD) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_VACCINES_EMP,
      payload: true
    });
    debugger;
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    rqGD.id_registro = id;
    let respGD;
    if(arGD){
     respGD = await GestorDocumentalServices.editDocument(arGD, rqGD)
    }else{
      respGD = await GestorDocumentalServices.saveDocument(rqGD);
    }
    const resp = await client.put(itype === 1 ? `/api/app/Formal_Empleado_Vacuna/${id}/` : `/api/app/Funcional_Empleado_Vacuna/${id}/`, {
      ...data,
      archivos_gestor: arGD ? respGD.data.id :respGD.data.resultado.id
    }, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});

    const { vacsEmp, vacsEmpLength } = getState().vaccinesEmp;
    vacsEmp[index] = resp.data;
    //vacsEmp[index].archivo_gestor = respGD.data.resultado;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_VACCINES_EMP,
      payload: {
        vacsEmp: vacsEmp,
        vacsEmpLength: vacsEmpLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      switch (ex.response.status) {
        case 400:
          if(Array.isArray(ex.response.data)){
            ex.response.data.forEach(item => {
              toastr.error(item);
            });
          }else{
            toastr.error(ex.response.data);
          }  
          break;
        case 404:
          if(ex.response.data.mensaje){
            if(Array.isArray(ex.response.data.mensaje)){
              debugger;
              ex.response.data.mensaje.forEach(item => {
                toastr.error(item.response);
              });
            }else{
              toastr.error(ex.response.data.mensaje);
            }
          }else{
            toastr.error(messages.notFound);
          }
          break;
        default:
          errorManage(ex);
          break;
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_VACCINES_EMP,
      payload: false
    });
  }
}

export const deleteVaccinesEmp = (id, index, itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_VACCINES_EMP,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(itype === 1 ? `/api/app/Formal_Empleado_Vacuna/${id}/` : `/api/app/Funcional_Empleado_Vacuna/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { vacsEmp, vacsEmpLength } = getState().vaccinesEmp;
    vacsEmp.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_VACCINES_EMP,
      payload: {
        vacsEmp: vacsEmp,
        vacsEmpLength: vacsEmpLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_VACCINES_EMP,
      payload: false
    });
  }
}